export const PlatformConnection = {
  make: ({ compId = '', role = 'textRole', config = {} }) => ({ compId, role, config }),
}
